// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store'
/* 路由 */
import router from './router'

/* axios */
import axios from 'axios'
import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
  ak: 'u0ANfWknmYrE0ouyD7jMumQtVHDvPosm'
})
Vue.prototype.$axios = axios;

Vue.use(ElementUI, {
  size: 'small'
})

import './assets/skin/css/style.css'
import './assets/skin/css/common.css'
import './assets/skin/js/jquery.js'
import './assets/skin/css/style.css'
import './assets/skin/js/common.js'
import './assets/skin/css/jquery.slidebox.css'
import './assets/skin/js/jquery.slidebox.min.js'
import './assets/skin/js/jSignature.min.js'

// /* jquery */
import 'jquery'
/* swiper */
import 'swiper/dist/css/swiper.min.css';
// /* bootstarp */
// import './assets/css/bootstrap.min.css'
// import './assets/js/bootstrap.min'

// /* animate.css */
// import 'animate.css'


/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name, Header)


/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name, Footer)

/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name, GoTop)

Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }



  next();
});

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js